import React from 'react';
import * as styles from './details.style';
import { Address } from './address';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var Details = _ref => {
  var address = _ref.address,
    href = _ref.href,
    listingId = _ref.listingId,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? null : _ref$type,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? () => {} : _ref$onClick;
  var street = address.street,
    division = address.division,
    state = address.state,
    postcode = address.postcode;
  var isStreetOnly = street && !(division || state || postcode);
  return ___EmotionJSX("div", {
    css: styles.newHomesListingCardDetails
  }, ___EmotionJSX("div", {
    css: styles.address
  }, ___EmotionJSX("a", {
    css: styles.link,
    href: href !== null && href !== void 0 ? href : undefined,
    id: "allhomes-search-listing-card-listing-details-".concat(listingId),
    onClick: onClick
  }, isStreetOnly ? street : ___EmotionJSX(Address, address))), type && ___EmotionJSX("div", {
    css: styles.type
  }, type));
};